import { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { tryCatch } from 'ramda';

// TODO: this is a temporary solution, the Bambuser team will add an event to the player that we can listen to
// something like: player.on('surf-behind-to', handleRedirect);
export const useHandleBambuserRedirects = () => {
  const history = useHistory();

  const handleRedirect = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== 'https://lcx-player.bambuser.com') return;

      const data = tryCatch(
        () => JSON.parse(event.data),
        () => ({})
      )();

      if (data.eventName !== 'livecommerce:minimize') return;

      const url = new URL(data.data.url);
      history.push(url.pathname + url.search);
    },
    [history]
  );

  useEffect(() => {
    window.addEventListener('message', handleRedirect);

    return () => {
      window.removeEventListener('message', handleRedirect);
    };
  }, [handleRedirect]);
};
